import MicroModal from "micromodal";

class AppModal{
    constructor(document) {
        this.doc = document;
        this.modal = this.doc.querySelector('#app-modal');

        if(this.checkCookie('app-modal') == false){
            this.setCookie('app-modal', true, 1);
            this.init();
        }
    }

    init = () => {
        MicroModal.init({
            openClass: 'is-open',
        });
        
        setTimeout(() => {
            MicroModal.show('app-modal');
        }, 3000);
    }

    // Set a cookie with a name, value, and expiration date
     setCookie = (name, value, expirationDays) => {
        const date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // check if cookie exists
    checkCookie = (cookieName) => {
        const cookies = document.cookie.split(';');
        
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          
          // Check if the cookie starts with the specified name
          if (cookie.startsWith(cookieName + '=')) {
            console.log(cookieName + ' cookie found')
            return true; // Cookie found
          }
        }
        
        console.log(cookieName + ' cookie not found')
        return false; // Cookie not found
      }
}

// TODO: Re-enable when 2024 app is to be advertised
// new AppModal(document);